import { render, staticRenderFns } from "./batchSetting.vue?vue&type=template&id=0e68d544"
import script from "./batchSetting.vue?vue&type=script&lang=js"
export * from "./batchSetting.vue?vue&type=script&lang=js"
import style0 from "./batchSetting.vue?vue&type=style&index=0&id=0e68d544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports